import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllTypes } from "../../../redux/typeSlice";

import ReactSelect from "../../ReactSelect/ReactSelect";

const TypesDropdown = ({
  defaultValue,
  onChange,
  typesDropdownType="S", //S=SIMILAR, D=DIFFERENT
  typeDtls,
  isDisabled = false,
}) => {
  const { types } = useSelector((state) => state.type);
  const dispatch = useDispatch();
  const otherProps = {};

  if (defaultValue) {
    otherProps.defaultValue = defaultValue;
  }

  useEffect(() => {
    dispatch(getAllTypes({}));
  }, [dispatch]);

  let options = structuredClone(types);
  const referenceType =
    typeDtls ||
    (defaultValue ? types.find((t) => t.type_id === defaultValue.value) : null);

  if (typesDropdownType === "S" && referenceType) {

    options = options.filter((type) =>{
      if(type.is_procedure === referenceType.is_procedure){
        return true;
      }
    });

  }

  options = options.map((t) => ({ value: t.type_id, label: t.name }));
  return (
    <>
      <ReactSelect
        options={options}
        onChange={onChange}
        defaultValue={defaultValue}
        isDisabled={isDisabled}
      />
    </>
  );
};

export default TypesDropdown;
